import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  useLoadScript,
  DirectionsRenderer,
  Marker,
} from "@react-google-maps/api";
import originMarker from "../assets/images/originMarker.svg";
import destinationMarker from "../assets/images/map_2.png";
import { OverlayView } from "@react-google-maps/api";

const RouteMap = ({ origin, destination }) => {
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const mapRef = useRef(null);

  // Load Google Maps script
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    libraries: ["places"],
  });

  useEffect(() => {
    if (isLoaded && origin && destination) {
      calculateRoute();
    }
  }, [isLoaded, origin, destination]);

  const calculateRoute = () => {
    if (!origin || !destination) {
      console.error("Origin or Destination is missing.");
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();
    const request = {
      origin,
      destination,
      travelMode: window.google.maps.TravelMode.DRIVING,
    };

    directionsService.route(request, (result, status) => {
      if (status === window.google.maps.DirectionsStatus.OK) {
        setDirectionsResponse(result);
      } else {
        console.error("Error fetching directions: ", status);
      }
    });
  };

  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const mapOptions = {
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
  };

  const defaultCenter = {
    lat: 23.036503,
    lng: 72.571763,
  };
  if (!isLoaded) {
    return <div>Loading map...</div>;
  }

  if (loadError) {
    return <div>Error loading Google Maps: {loadError.message}</div>;
  }
  const getBearing = (start, end) => {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const toDeg = (rad) => (rad * 180) / Math.PI;

    const lat1 = toRad(start.lat);
    const lng1 = toRad(start.lng);
    const lat2 = toRad(end.lat);
    const lng2 = toRad(end.lng);

    const dLng = lng2 - lng1;

    const y = Math.sin(dLng) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);

    const bearing = toDeg(Math.atan2(y, x));
    return (bearing + 360) % 360; // Normalize to 0-360
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        // background: "white",
        borderRadius: "14px",
        overflow: "hidden",
        // padding: "10px",
        // boxShadow: "3px 4px 9px 1px rgba(0, 0, 0, 0.19)",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={origin.lat == "" ? defaultCenter : origin}
          zoom={7}
          options={mapOptions}
          onLoad={(map) => (mapRef.current = map)}
        >
          {directionsResponse && (
            <DirectionsRenderer
              directions={directionsResponse}
              options={{
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: "rgba(73, 115, 132, 1)",
                  strokeOpacity: 0.8,
                  strokeWeight: 5,
                },
              }}
            />
          )}

          {origin && (
            <OverlayView
              position={origin}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              getPixelPositionOffset={(width, height) => ({
                x: -(width / 2),
                y: -(height / 2),
              })}
            >
              <div
                className="vehicle-marker"
                style={{
                  transform: `translate(-50%, -50%) rotate(${getBearing(
                    origin,
                    destination
                  )}deg)`,
                  backgroundImage: `url(${originMarker})`,
                  width: "28px",
                  height: "51px",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  position: "absolute",
                  cursor: "pointer",
                  left: "50%",
                  top: "50%",
                }}
              />
            </OverlayView>
          )}

          {destination && (
            <Marker
              position={destination}
              icon={{
                url: destinationMarker,
                scaledSize: new window.google.maps.Size(30, 30),
              }}
            />
          )}
        </GoogleMap>
      </div>
    </div>
  );
};
// const RouteMap = React.memo(RouteMapComponent);
export default React.memo(RouteMap);
